<template>
  <v-col :cols="props.showButtons ? 4 : 2">
    <v-btn
      icon
      variant="text"
      :disabled="isDisconnected"
      :loading="isLoading"
      @click="reloadValue"
    >
      <v-icon>refresh</v-icon>
      <v-tooltip
        activator="parent"
        location="bottom"
        :disabled="isDisconnected || isReloadDisabled"
      >
        Reload
      </v-tooltip>
    </v-btn>
    <v-btn
      v-if="props.showButtons"
      icon
      variant="text"
      :disabled="isDisconnected || isSetDefaultDisabled"
      @click="setDefault"
    >
      <v-icon>restore</v-icon>
      <v-tooltip
        activator="parent"
        location="bottom"
        :disabled="isDisconnected || isSetDefaultDisabled"
      >
        default: {{ defaultValue }}
      </v-tooltip>
    </v-btn>
    <v-btn v-if="props.showButtons" icon variant="text">
      <v-icon>info</v-icon>
      <v-tooltip activator="parent" location="bottom">
        mbus_address: {{ props.parameter[ParamField.mbusAddress] }}<br />
        param_type: {{ props.parameter[ParamField.type] }}<br />
        user_info: {{ props.parameter[ParamField.userInfo] }}
      </v-tooltip>
    </v-btn>
  </v-col>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { ParamField } from "../enums/ParamField";
import { PortState } from "@/enums/PortState";
import { useModbusStore } from "@/stores/useModbusStore";
import { ModbusParam } from "@/types/ModbusParam";

const modbusStore = useModbusStore();

const props = defineProps<{
  defaultValue: unknown;
  isLoading: boolean;
  isReloadDisabled: boolean;
  isSetDefaultDisabled: boolean;
  parameter: ModbusParam;
  showButtons: boolean;
}>();

const emit = defineEmits<{
  (event: "reloadValue"): void;
  (event: "setDefault"): void;
}>();

const isDisconnected = computed<boolean>(
  () => modbusStore.portState === PortState.disconnected,
);

function reloadValue() {
  emit("reloadValue");
}

function setDefault() {
  emit("setDefault");
}
</script>

<style scoped lang="scss"></style>
